import { useState, useRef } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { appConfig } from "../../utils/config";
import { languageLabels } from "../../utils/formUtils";
import "../../components/HeaderComponents/NavBar.css";

const availablePublicLanguages = appConfig.languages.available.map((code) => {
  const displayName =
    new Intl.DisplayNames([code], { type: "language" }).of(code) || code;
  const label = displayName.charAt(0).toUpperCase() + displayName.slice(1);
  return { code, label };
});

const PublicHeader = ({
  logo,
  i18n,
  t,
  onLogin,
  onRegister,
  isLoading = false,
  onChangeLanguage,
}) => {
  const [langOpen, setLangOpen] = useState(false);
  const langRef = useRef(null);

  const currentLanguageLabel =
    t(languageLabels[i18n.language] || "navbar.english");

  const changeLanguage = (lng) => {
    onChangeLanguage(lng);
    setLangOpen(false);
  };

  return (
    <header className="appbar custom-appbar">
      <div className="toolbar custom-toolbar">
        <div className="header-left">
          {logo && <img src={logo} alt="Brand Logo" className="brand-logo" />}
        </div>

        <div className="header-right">
          <div
            className="language-selector"
            onMouseLeave={() => setLangOpen(false)}
            ref={langRef}
          >
            <button
              className="dropdown-button dropdown-button-pw"
              onClick={() => setLangOpen((open) => !open)}
              type="button"
            >
              {currentLanguageLabel}
              <div className="arrowLanguage">
                <KeyboardArrowDownIcon fontSize="small" />
              </div>
            </button>

            {langOpen && (
              <ul className="dropdown-menu">
                {availablePublicLanguages.map(({ code, label }) => (
                  <li key={code}>
                    <button type="button" onClick={() => changeLanguage(code)}>
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <button
            className="header-button"
            onClick={onLogin}
            disabled={isLoading}
          >
            {isLoading ? "..." : t("publicWebsite.login")}
          </button>

          <button
            className="header-button"
            onClick={onRegister}
            disabled={isLoading}
          >
            {t("publicWebsite.signup")}
          </button>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
